(function () {
  var COOKIE_PREFIX = "zf_";
  var TTL_DAYS = 30;
  var ZOHO_ENDPOINT_MARKER = "zohopublic.com";

  var CLICK_ID_KEYS = ["gclid", "fbclid", "ttclid", "ScCid"];

  var CLICK_ID_MAP = {
    gclid:  "SingleLine3",
    fbclid: "SingleLine4",
    ttclid: "SingleLine5",
    ScCid:  "SingleLine6"
  };

  var UTM_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ];

  var ALL_PARAMS = UTM_PARAMS.concat(CLICK_ID_KEYS);

  function setCookie(name, value) {
    var expires = new Date();
    expires.setDate(expires.getDate() + TTL_DAYS);
    document.cookie = COOKIE_PREFIX + name + "=" + encodeURIComponent(value) +
      "; expires=" + expires.toUTCString() +
      "; path=/";
  }

  function deleteCookie(name) {
    document.cookie = COOKIE_PREFIX + name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  }

  function getCookie(name) {
    var fullName = COOKIE_PREFIX + name + "=";
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
      if (cookies[i].indexOf(fullName) === 0) {
        return decodeURIComponent(cookies[i].substring(fullName.length));
      }
    }
    return "";
  }

  function decodeParam(str) {
    try {
      return decodeURIComponent(str.replace(/\+/g, " "));
    } catch (e) {
      return str;
    }
  }

  function getUrlParams() {
    var params = {};
    try {
      var qs = window.location.search.substring(1);
      if (!qs) return params;
      var pairs = qs.split("&");
      for (var i = 0; i < pairs.length; i++) {
        var idx = pairs[i].indexOf("=");
        var key, val;
        if (idx > -1) {
          key = decodeParam(pairs[i].substring(0, idx));
          val = decodeParam(pairs[i].substring(idx + 1));
        } else {
          key = decodeParam(pairs[i]);
          val = "";
        }
        if (val) params[key] = val;
      }
    } catch (e) {}
    return params;
  }

  function setField(name, value) {
    var els = document.getElementsByName(name);
    for (var i = 0; i < els.length; i++) {
      els[i].value = value;
    }
  }

  function getTracking() {
    var data = {};
    for (var i = 0; i < ALL_PARAMS.length; i++) {
      var val = getCookie(ALL_PARAMS[i]);
      if (val) data[ALL_PARAMS[i]] = val;
    }
    var url = getCookie("landing_url");
    data._landing_url = url || window.location.href;
    return data;
  }

  function ensureField(form, name, value, overwrite) {
    if (!value) return;
    var existing = form.querySelector('[name="' + name + '"]');
    if (existing) {
      if (!existing.value || overwrite) existing.value = value;
    } else {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
  }

  function injectIntoZohoForm(form) {
    var tracking = getTracking();

    for (var param in CLICK_ID_MAP) {
      if (tracking[param]) {
        ensureField(form, CLICK_ID_MAP[param], tracking[param], true);
      }
    }

    if (tracking.gclid) {
      ensureField(form, "zc_gad", tracking.gclid, true);
    }

    for (var u = 0; u < UTM_PARAMS.length; u++) {
      if (tracking[UTM_PARAMS[u]]) {
        ensureField(form, UTM_PARAMS[u], tracking[UTM_PARAMS[u]], true);
      }
    }

    ensureField(form, "referrername", window.location.href, true);
    if (tracking._landing_url) {
      ensureField(form, "zf_referrer_name", tracking._landing_url, true);
    }
  }

  function clearStaleClickIds(freshKey) {
    for (var i = 0; i < CLICK_ID_KEYS.length; i++) {
      if (CLICK_ID_KEYS[i] !== freshKey) {
        deleteCookie(CLICK_ID_KEYS[i]);
      }
    }
  }

  function captureParams() {
    var urlParams = getUrlParams();

    var freshClickId = null;
    for (var c = 0; c < CLICK_ID_KEYS.length; c++) {
      if (urlParams[CLICK_ID_KEYS[c]]) {
        freshClickId = CLICK_ID_KEYS[c];
        break;
      }
    }
    if (freshClickId) {
      clearStaleClickIds(freshClickId);
    }

    for (var i = 0; i < ALL_PARAMS.length; i++) {
      var key = ALL_PARAMS[i];
      if (urlParams[key]) {
        setCookie(key, urlParams[key]);
      }
    }

    var hasParams = window.location.href.indexOf("?") > -1;
    if (hasParams || !getCookie("landing_url")) {
      setCookie("landing_url", window.location.href);
    }
  }

  function populateExistingFields() {
    for (var i = 0; i < ALL_PARAMS.length; i++) {
      var key = ALL_PARAMS[i];
      var val = getCookie(key);
      if (!val) continue;

      if (CLICK_ID_MAP[key]) {
        setField(CLICK_ID_MAP[key], val);
      } else {
        setField(key, val);
      }
    }

    var gclid = getCookie("gclid");
    if (gclid) setField("zc_gad", gclid);

    setField("referrername", window.location.href);
    var landingUrl = getCookie("landing_url");
    if (landingUrl) {
      setField("zf_referrer_name", landingUrl);
    }
  }

  function interceptFormSubmissions() {
    var origSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (this.action && this.action.indexOf(ZOHO_ENDPOINT_MARKER) > -1) {
        injectIntoZohoForm(this);
      }
      return origSubmit.apply(this, arguments);
    };

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf(ZOHO_ENDPOINT_MARKER) > -1) {
        injectIntoZohoForm(form);
      }
    }, true);

    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeName === "FORM" && node.action &&
              node.action.indexOf(ZOHO_ENDPOINT_MARKER) > -1) {
            injectIntoZohoForm(node);
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    captureParams();
    populateExistingFields();
    interceptFormSubmissions();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
